import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Helpers } from "./helpers";
import { AuthenticationService } from "./authentication.service"
import Swal from 'sweetalert2';
import { session } from '../environments/environment.session'
import { en as enk } from '../environments/environments.k'
import { en } from '../environments/environment.tok'
import * as CryptoJS from 'crypto-js';
import { interval, Subscription } from 'rxjs';
import { SpinnerService } from './shared/spinner.service'
import { Utf8EncodingService } from './md/service/utf8-encoding.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'body',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  title = 'app';
  erpUser:any=undefined
  private subscription!: Subscription;
  sp:any=false
  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
		this.network()
  }
  
  @HostListener('window:scroll', [])
onScroll() {
  this.showButton = window.scrollY > 300;
}

scrollToTop() {
//   window.scrollTo({ top: 0, behavior: 'smooth' });
  const duration = 1000; // scroll duration in ms (1000 = 1s, increase for slower)
  const start = window.scrollY;
  const startTime = performance.now();

  const animateScroll = (currentTime: number) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1); 

    // easeOutCubic for smooth feel
    const ease = 1 - Math.pow(1 - progress, 3);

    window.scrollTo(0, start * (1 - ease));

    if (progress < 1) {
      requestAnimationFrame(animateScroll);
    }
  };

  requestAnimationFrame(animateScroll);
}

  intervalId: any;
  showButton = false;

  network(){
	if(!navigator.onLine ){
		this.sp=true
		this.tsppinner.show('opps !! Network Issue','Check the internet')
	}
	if(navigator.onLine  && this.sp){
		this.tsppinner.hide()
		if (this.subscription) {
			this.subscription.unsubscribe();
		  }
		this.sp=false
	}

	if(!navigator.onLine ){
		this.check()
	}
  }


  check(){
	this.subscription = interval(1000) // 15 seconds in milliseconds
	.subscribe(() => {
		if (this.subscription) {
			this.subscription.unsubscribe();
		  }
	  this.network();
	});
  }

  constructor(
    private _router: Router, 
    private AuthenticationService: AuthenticationService,
    private tsppinner: SpinnerService,
    private spinner: NgxSpinnerService,
    private utf8EncodingService: Utf8EncodingService
  ) {
    try {
		this.erpUser = JSON.parse(sessionStorage.getItem('1001') as any);
    } catch (err) {
      sessionStorage.clear();
      // this._router.navigate(['./index']);
      return;
    }

  }



  async ngOnInit() {

	Helpers.setLoading(false);
	await this.getserver();
	en.temppu=await this.decryptUsingAES256(en.temppu)
	en.temppa=await this.decryptUsingAES256(en.temppa)
	if(this.severListen) {
		this.gon=true
		this._router.navigate(['/error']);
		return;
	}

	  if (sessionStorage.getItem('1001') == undefined || sessionStorage.getItem('1001') == null) {
		this.gon=true
	 	 this._router.navigate(['/login'])
	  }else{
		this.gon=false
			await this.getErpUser()

			if (this.erpUser['b_acct_id'] == 0) {
				this._router.navigate(['./solution-admin/index']);
			} else {
				if (this.erpUser['role_cd'].includes('DIRECTOR') || this.erpUser['role_cd'].includes('Dir')  ) {
					this._router.navigate(['./file-o0verView']);
				  }else{
					this._router.navigate(['/index']);
				  }
			}
		}

	this.getAllLabel();
    this.getSystemModule();
    this.getAllLanguage();
		this._router.events.subscribe((route) => {
			if (route instanceof NavigationStart) {
				this.spinner.show();
				Helpers.bodyClass('fixed-navbar');
			}
			if (route instanceof NavigationEnd) {
				window.scrollTo(0, 0);
				this.spinner.hide();
				if(route.url=='/login' && sessionStorage.getItem('1001') == undefined || sessionStorage.getItem('1001') == null ){
					this._router.navigate(['/login']);
				}
			}

		});

		Helpers.setLoading(false);

	}



decryptUsingAES256(text:any) {
		let _key = CryptoJS.enc.Utf8.parse(enk.jumpOT);
		let _iv = CryptoJS.enc.Utf8.parse(enk.jumpOT);
		let decrypted = CryptoJS.AES.decrypt(
			text, _key, {
			keySize: 16,
			iv: _iv,
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7
		}).toString(CryptoJS.enc.Utf8);
		return decrypted;
}

    gon:boolean=true
	async getErpUser(){
		let obj={}
		let resp=await this.AuthenticationService.getErpUser((obj))
		if(resp['error']==false){
			this.erpUser=JSON.parse(resp['data'][0]['erpUser'])

			
			this.gon=true
			// session.erpUser=btoa(resp['data'][0]['erpUser'])
			session.erpUser= this.utf8EncodingService.encodeToUtf8(resp['data'][0]['erpUser'])
		}else{
			Swal.fire('Error',resp['data'],'error')
		}
	}

	allLanguage = []
	async getAllLanguage() {
		var obj = new Object();
		var resp = await this.AuthenticationService.getAllLanguages(JSON.stringify(obj));
		if (resp['error'] == false) {
			this.AuthenticationService.allLanguage = resp.data;
			this.AuthenticationService.language_cd = resp.data[0]['language_cd']
		} else {

		}
	}

	async getSystemModule() {
		let obj:any = new Object();
		obj['b_acct_id'] = 0;
		var resp = await this.AuthenticationService.getModules(JSON.stringify(obj));
		if (resp['error'] == false) {
			  obj = new Object();
			for (let i = 0; i < resp.data.length; i++) {
				obj[resp.data[i]['module_cd']] = resp.data[i]['module_name']
			}
			this.AuthenticationService.allSystemModuleObj = obj;

		} else {

		}
	}
	severListen:any=false;
	async getserver() {
		var resp = await this.AuthenticationService.getserver(JSON.stringify({}));
		if (resp['error'] ) {
			this.severListen=resp['error']
			this._router.navigate(['/error']);
		}
	}


	allLabel = []
	async getAllLabel() {
		var obj:any = new Object();
		obj['module_cd']=["COMMON","MD"]
		var resp = await this.AuthenticationService.getcomponentLabelvalueswithLanguage(JSON.stringify(obj));
		if (resp['error'] == false) {
			this.AuthenticationService.allLabel = resp.data;
		 let  obj:any = new Object();
			for (let i = 0; i < resp.data.length; i++) {
				obj[resp.data[i]['language_cd'] + resp.data[i]['component_cd'] + resp.data[i]['label_no']] = resp.data[i]['value_to_show'];
			}
			this.AuthenticationService.allLableShowObj = obj;

		} else {

		}
	}

	/********************************************** auto logout code start ************************************************ */
	@HostListener('document:mousemove', ['$event']) MouseMove() {this.resetTimer()}
	@HostListener('document:keypress', ['$event']) KeyBord() {this.resetTimer()}
	// @HostListener('window:beforeunload', ['$event']) windowBeforeUnload() {this.logOut()}

	timer:any
	time_out_time = 30; // in minutes
	resetTimer() {
		clearTimeout(this.timer);
		this.timer = setTimeout(async () => {
			await this.logOut()
		}, this.time_out_time * 60 * 1000); // 30 minutes in milliseconds
	}

	async logOut() {
		if (window.location.hash != '#/login' && !this.AuthenticationService.uiHost.startsWith('localhost')
		    && !this.AuthenticationService.uiHost.startsWith('tracking.upda.co.in')) {
			Swal.fire('opps..', 'Your session is expired please login again', 'info')
			sessionStorage.removeItem('1000')
			sessionStorage.removeItem('1001')
			 session.erpUser={}
			this._router.navigate(['/login']);
		}
	}



	/********************************************** auto logout code end *****************************************************/
}
